import { render } from "./Form.vue?vue&type=template&id=767e810c"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"
script.render = render

export default script